import { lazy } from 'react';

export const backoffice = {
  Landing: lazy(() => import('./Landing')),
  Customers: lazy(() => import('./Customers')),
  Settings: lazy(() => import('./Settings'))
};
